import '../index.css';

export { default as miniPageRoutes } from './PageRoutes';
export * from './PageRoutes';
